import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDynamicReducerSelector } from '@core/js/components/common/ChangeForm/store';
import { useTranslations } from '@core/js/hooks/i18n';
import { COMMON_REQUIRED_MESSAGE } from '@theme/js/components/common/ChangeForm/constants';
import { validationCallbackCreator } from './helpers';

export const useRequiredValidationMessages = (validationConfig) => {
    const fields = useDynamicReducerSelector(prop('fields'));
    const t = useTranslations();

    const getPasswordOrTextTarget = useCallback(({ key }) => ({
        name: key['name'],
        requiredMessage: t(validationConfig[key.name]?.find(el => el.type === 'required')?.message)
    }), [t, validationConfig]);

    const getRequiredTarget = useCallback(() => ({
        name: 'requiresConfirmation',
        requiredMessage: t(COMMON_REQUIRED_MESSAGE)
    }), [t]);

    return useCallback(() => validationCallbackCreator(fields, getPasswordOrTextTarget, getRequiredTarget), [
        fields, getPasswordOrTextTarget, getRequiredTarget
    ]);
};
